import { Link } from 'react-router-dom';

export default function Nist80053Framework() {
  return (
    <div className="bg-background-primary">
      <section className="relative overflow-hidden py-16" style={{ background: "var(--gradient-hero)" }}>
        <div className="pointer-events-none absolute inset-0">
          <div className="aurora" />
          <div className="noise" />
        </div>

        <div className="container-ivalue relative">
          <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">
            International Frameworks / NIST 800-53
          </div>

          <h1 className="mt-4 text-balance text-4xl font-extrabold tracking-[-0.03em] text-text-primary md:text-6xl">
            NIST SP 800-53 Rev. 5
            <br />
            Security & Privacy Controls
          </h1>

          <p className="mt-5 max-w-3xl text-lg leading-relaxed text-text-secondary">
            The most comprehensive control catalog for federal systems, widely adopted by enterprises requiring rigorous security.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#families"
              className="focus-ring sheen inline-flex h-12 items-center justify-center rounded-xl bg-gradient-to-r from-[#10B981] to-[#059669] px-5 text-sm font-semibold text-white transition-transform hover:scale-[1.02] active:scale-[0.98]"
            >
              View Control Families
            </a>
            <Link
              to="/frameworks/india/rbi"
              className="focus-ring inline-flex h-12 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-5 text-sm font-semibold text-text-primary transition-colors hover:bg-white/10"
            >
              Back to India
            </Link>
          </div>

          <div className="mt-10 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {[
              { k: "Control Families", v: "20" },
              { k: "Controls", v: "1,000+" },
              { k: "Baselines", v: "Low/Mod/High" },
            ].map((s) => (
              <div key={s.k} className="glass-card sheen p-5">
                <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">{s.k}</div>
                <div className="mt-2 font-[family:var(--font-space-grotesk)] text-3xl font-semibold text-text-primary">{s.v}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-secondary py-20" id="families">
        <div className="container-ivalue">
          <div className="glass-card p-6">
            <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Control families</div>
            <div className="mt-4 grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
              {[
                "AC (Access Control)",
                "AT (Awareness)",
                "AU (Audit)",
                "CA (Assessment)",
                "CM (Configuration)",
                "CP (Contingency)",
                "IA (Identification)",
                "IR (Incident Response)",
                "MA (Maintenance)",
                "MP (Media Protection)",
                "PE (Physical)",
                "PL (Planning)",
                "PM (Program Management)",
                "PS (Personnel)",
                "PT (Privacy)",
                "RA (Risk Assessment)",
                "SA (System Acquisition)",
                "SC (System Communications)",
                "SI (System Integrity)",
                "SR (Supply Chain)",
              ].map((x) => (
                <div key={x} className="rounded-xl border border-border-subtle bg-white/5 px-3 py-2 text-sm text-text-secondary">
                  {x}
                </div>
              ))}
            </div>

            <div className="mt-6 text-sm text-text-tertiary">
              Full 800-53 catalog ingestion (1,000+ controls) will be added in Part 5 as a structured dataset + family navigator.
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
